import { ISurveyTranslation } from "../../../@types/admin/AdminSurveyTranslation";

/**
 * A survey translation has no id — `(key, languageCode, usedLocation)` is its
 * identity, and that triple is also what the PUT re-sends alongside the new
 * value. This builds the composite key the grid uses to track edits.
 *
 * The parts are joined with a separator that cannot appear in any of them, so
 * two different rows can never collapse into one edit.
 */
export function translationRowId(translation: ISurveyTranslation): string {
  return [
    translation.key,
    translation.languageCode,
    translation.usedLocation,
  ].join("\u0000");
}
